export const useDocumentTokenIdPositionMapStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentTokenIdPositionMap(documentId, revision.id)();
};
